export default __webpack_public_path__ + "static/media/cocina-desktop.d95d9621.jpg";